/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Explorer_Display_File_Name_TextInputs */

const en_explorer_display_file_name_text = /** @type {(inputs: Explorer_Display_File_Name_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Please enter a file name:`)
};

const fr_explorer_display_file_name_text = /** @type {(inputs: Explorer_Display_File_Name_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Veuillez entrer un nom de fichier :`)
};

const de_explorer_display_file_name_text = /** @type {(inputs: Explorer_Display_File_Name_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bitte geben Sie einen Dateinamen ein:`)
};

const it_explorer_display_file_name_text = /** @type {(inputs: Explorer_Display_File_Name_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inserisci un nome file:`)
};

const ru_explorer_display_file_name_text = /** @type {(inputs: Explorer_Display_File_Name_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Пожалуйста, введите имя файла:`)
};

const es_explorer_display_file_name_text = /** @type {(inputs: Explorer_Display_File_Name_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Por favor, introduzca un nombre de archivo:`)
};

const zh_cn2_explorer_display_file_name_text = /** @type {(inputs: Explorer_Display_File_Name_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`请输入文件名：`)
};

const ja_explorer_display_file_name_text = /** @type {(inputs: Explorer_Display_File_Name_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ファイル名を入力してください:`)
};

const hi_explorer_display_file_name_text = /** @type {(inputs: Explorer_Display_File_Name_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`कृपया फ़ाइल का नाम दर्ज करें:`)
};

const pt_pt2_explorer_display_file_name_text = /** @type {(inputs: Explorer_Display_File_Name_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Por favor, insira um nome de arquivo:`)
};

/**
* | output |
* | --- |
* | "Please enter a file name:" |
*
* @param {Explorer_Display_File_Name_TextInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const explorer_display_file_name_text = /** @type {((inputs?: Explorer_Display_File_Name_TextInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Explorer_Display_File_Name_TextInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_explorer_display_file_name_text(inputs)
	if (locale === "de") return de_explorer_display_file_name_text(inputs)
	if (locale === "it") return it_explorer_display_file_name_text(inputs)
	if (locale === "ru") return ru_explorer_display_file_name_text(inputs)
	if (locale === "es") return es_explorer_display_file_name_text(inputs)
	if (locale === "zh-CN") return zh_cn2_explorer_display_file_name_text(inputs)
	if (locale === "ja") return ja_explorer_display_file_name_text(inputs)
	if (locale === "hi") return hi_explorer_display_file_name_text(inputs)
	if (locale === "pt-PT") return pt_pt2_explorer_display_file_name_text(inputs)
	return en_explorer_display_file_name_text(inputs)
});